import { Check, Copy } from "lucide-react";
import { useCallback, useState } from "react";

export function SetupCopyBlock({
	text,
	prefix,
	multiline,
}: {
	text: string;
	prefix?: string;
	multiline?: boolean;
}) {
	const [copied, setCopied] = useState(false);
	const handleCopy = useCallback(async () => {
		await navigator.clipboard.writeText(text);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	}, [text]);

	return (
		<button
			type="button"
			onClick={handleCopy}
			className="group relative flex w-full items-start gap-3 rounded-md border border-border bg-background px-4 py-3 text-left font-mono text-sm leading-relaxed text-foreground transition-colors hover:border-foreground/20 hover:bg-muted/40"
		>
			{prefix ? (
				<span className="select-none text-muted-foreground">{prefix}</span>
			) : null}
			<span
				className={`min-w-0 flex-1 ${multiline ? "whitespace-pre-wrap" : "truncate"}`}
			>
				{text}
			</span>
			<span className="ml-auto inline-flex shrink-0 items-center gap-1 text-xs text-muted-foreground transition-colors group-hover:text-foreground">
				{copied ? (
					<Check className="size-3.5 text-emerald-500" />
				) : (
					<Copy className="size-3.5" />
				)}
			</span>
		</button>
	);
}
